import { Api } from '../api';
import { GetWorkspaceRolesResponse } from '../auth';
import { RenameRoleRequest } from './model';

export const superAdminApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    createSupportUser: builder.mutation<any, any>({
      query(body) {
        return {
          url: `admin/user`,
          method: 'POST',
          body: body,
        };
      },
    }),
    renameRole: builder.mutation<any, RenameRoleRequest>({
      query(body) {
        return {
          url: `admin/role/create`,
          method: 'POST',
          body: body,
        };
      },
    }),
    mappingReport: builder.mutation<any, any>({
      query(body) {
        return {
          url: `reports/api/v2/mapping-report`,
          method: 'POST',
          body: body,
        };
      },
    }),
    mappingDownload: builder.mutation<any, any>({
      query(body) {
        return {
          url: `reports/api/v2/mapping-report/download`,
          method: 'POST',
          body: body,
          responseHandler: (response) => response.arrayBuffer(),
        };
      },
    }),
    getWorkspaceRolesList: builder.query<GetWorkspaceRolesResponse, any>({
      query: (args) => {
        return {
          url: 'workspaces/roles/permissions',
          method: 'GET',
          params: args,
        };
      },
    }),
    getUserSupportList: builder.query<any, { params?: any } | void>({
      query(arg) {
        return {
          url: `admin/users`,
          method: 'GET',
          params: arg && arg?.params,
        };
      },
    }),
    getWabaUsersList: builder.query<any, any>({
      query(arg) {
        const { params } = arg;
        return {
          url: `admin/whatsapp-config/v2`,
          method: 'GET',
          params: params,
        };
      },
    }),
    getWabaTemplateListByWabaId: builder.query<any, any>({
      query(arg) {
        const { wabaId } = arg;
        return {
          url: `admin/templates/platform/${wabaId}`,
          method: 'GET',
        };
      },
    }),
    getWabaMasterTemplateList: builder.query<any, any>({
      query(arg) {
        const { params } = arg;
        return {
          url: `admin/templates`,
          method: 'GET',
          params: params,
        };
      },
    }),
    createOrUpdateTemplate: builder.mutation<any, any>({
      query(arg) {
        const data = arg;
        return {
          url: `admin/templates/platform/update`,
          method: 'POST',
          body: data,
        };
      },
    }),
    getTemplatesForEdit: builder.query<any, any>({
      query(arg) {
        const { sellerWorkspaceId } = arg;
        const { params } = arg;
        return {
          url: `admin/templates/platform/${sellerWorkspaceId}`,
          method: 'GET',
          params: params,
        };
      },
    }),
    refreshTemplateList: builder.query<any, any>({
      query(arg) {
        const { sellerWorkspaceId } = arg;
        return {
          url: `admin/templates/refresh/${sellerWorkspaceId}`,
          method: 'GET',
        };
      },
    }),
    getPRFileChanges: builder.query<any, any>({
      query(arg) {
        return {
          url: `admin/platform/file-changes`,
          method: 'GET',
        };
      },
    }),
    createVersion: builder.mutation<any, any>({
      query(arg) {
        return {
          url: `admin/platform/version`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    publishTemplates: builder.mutation<any, any>({
      query(arg) {
        const { sellerWorkspaceId, body } = arg;
        return {
          url: `admintemplates/platform/publish/${sellerWorkspaceId}`,
          method: 'POST',
          body: body,
        };
      },
    }),
    getVersionList: builder.query<any, void>({
      query(arg) {
        return {
          url: `admin/platform/versions`,
          method: 'GET',
        };
      },
    }),
  }),
});
export const {
  useCreateSupportUserMutation,
  useRenameRoleMutation,
  useLazyGetWorkspaceRolesListQuery,
  useLazyGetUserSupportListQuery,
  useMappingReportMutation,
  useMappingDownloadMutation,
  useLazyGetWabaUsersListQuery,
  useLazyGetWabaTemplateListByWabaIdQuery,
  useLazyGetVersionListQuery,
  useLazyGetTemplatesForEditQuery,
  useLazyGetPRFileChangesQuery,
  useLazyRefreshTemplateListQuery,
  useCreateOrUpdateTemplateMutation,
  useCreateVersionMutation,
  usePublishTemplatesMutation,
  useLazyGetWabaMasterTemplateListQuery,
} = superAdminApi;
